import { Link, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import CreateProject from "../components/Projects/CreateProject";
import UserProfileCard from "../components/UserProfileCard";

const ADD_PROJECT_DESCRIPTION =
  "Add project details and related information.";

const AddProjectPage = () => {
  const navigate = useNavigate();

  return (
    <div className="relative">
      <UserProfileCard />
      <Link
        to="/project-management"
        className="inline-flex items-center gap-2 text-[#E761A0] hover:underline font-medium mb-3 text-lg"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Projects
      </Link>

      <div className="mb-8">
        <h1 className="text-[34px] lg:text-[38px] xl:text-[56px font-display font-light text-white mb-[15px] leading-[76px]">
          Add a project
        </h1>
        <p className="text-white max-w-[863px] text-lg font-light">
          {ADD_PROJECT_DESCRIPTION}
        </p>
      </div>

      <div className="add-project-page-wrapper">
        <CreateProject
          layout="page"
          isEditMode={false}
          isViewMode={false}
          onSuccess={() => navigate({ to: "/project-management" })}
          refreshProjects={undefined}
        />
      </div>
    </div>
  );
};

export default AddProjectPage;
